
/* ===== 음성 안내 정책 =====
   · 기본값 OFF — 켜기 전에는 어떤 화면에서도 소리가 나지 않는다
   · AI 대화 화면에 들어가면 자동으로 켜진다 (사용자가 직접 끈 적이 없을 때)
   · 켜져 있으면 검사 문항·안내 문구를 읽어 준다 (키오스크 접근성)
   · 동의·정보입력·설정·전체결과지는 개인정보가 섞이므로 낭독하지 않는다
*/
(function(){
  var PIA=window.PIA;
  /* 음성 안내를 켜면 검사 문항·안내를 읽어 준다.
     동의·입력 화면은 개인정보가 섞이므로 낭독하지 않는다. */
  var NO_READ={ chat:1, consent:1, setup:1, settings:1, fullreport:1 };
  var GREET='안녕하세요! 예담 톡 인적성 검사예요. 검사 시작하기를 눌러 주세요.';
  var TIP={
    chat:'편하게 이야기해 주세요. 정답은 없어요.',
    done:'필수 검사를 모두 완료했어요. 통합 결과를 확인해 보세요.',
    mindintro:'마음 건강 확인은 선택이에요. 원하지 않으면 하지 않아도 괜찮아요.',
    result:'검사 결과가 나왔어요.'
  };
  PIA._lastRead='';
  /* 같은 문구인지 판정할 때 쓰는 정규화 — 공백 차이로 중복 낭독되던 문제 방지 */
  PIA._norm=function(t){ return String(t||'').replace(/\s+/g,' ').trim(); };
  /* [2026-08-22] 그림으로 표현된 것은 읽지 않는다.
     그동안 낭독이 textContent 를 그대로 넘겨서, 표정 아이콘·화살표·이모지·
     그래프 축 숫자까지 "웃는 얼굴 오른쪽 화살표 팔십오" 식으로 읽혔다.
     시각 요소는 aria-hidden 이 붙어 있으므로 DOM 단계에서 걸러내고,
     문자열 단계에서 한 번 더 그림문자를 지운다. */
  var _NOREAD_SEL = 'svg,img,canvas,video,figure,[aria-hidden="true"],[data-noread],.no-read,'
                  + '.pia-choice__face,.pia-btn__ic,.pia-btn__ar,.pia-scale__ic,.pia-icon,'
                  + '.pia-badge__ic,.chartjs-size-monitor,script,style';
  PIA._elText = function(el){
    if(!el) return '';
    var c;
    try{ c = el.cloneNode(true); }catch(e){ return PIA._stripArt(el.textContent||''); }
    try{ c.querySelectorAll(_NOREAD_SEL).forEach(function(n){ try{ n.remove(); }catch(e){} }); }catch(e){}
    return PIA._stripArt(c.textContent || '');
  };
  PIA._stripArt = function(t){
    var x = String(t == null ? '' : t);
    try{
      /* 이모지·그림문자·기호 계열 제거 */
      x = x.replace(/[\u{1F000}-\u{1FAFF}\u{1F900}-\u{1F9FF}]/gu, ' ');   /* 이모지 전반 */
      x = x.replace(/[\u{2600}-\u{27BF}]/gu, ' ');                        /* 기타 기호·딩벳 */
      x = x.replace(/[\u{2190}-\u{21FF}\u{2B00}-\u{2BFF}]/gu, ' ');       /* 화살표 */
      x = x.replace(/[\u{FE00}-\u{FE0F}\u{200D}\u{20E3}]/gu, '');         /* 변이·결합 문자 */
      x = x.replace(/[\u{2500}-\u{257F}\u{25A0}-\u{25FF}]/gu, ' ');       /* 괘선·도형 */
      x = x.replace(/[✓✔✕✖★☆●○◆◇▶▷◀◁▲△▼▽·•·›»«‹→←↑↓]/g, ' ');
    }catch(e){
      /* 구형 브라우저: 유니코드 프로퍼티 미지원 시 최소 처리만 */
      x = x.replace(/[✓✔✕✖★☆●○◆◇▶◀▲▼·•›»→←↑↓]/g, ' ');
    }
    return x.replace(/\s+/g, ' ').trim();
  };
  PIA.autoRead=function(){
    try{
      var s=document.querySelector('section[data-view]:not(.hidden)'); if(!s) return;
      var v=s.dataset.view;
      if(!PIA.ttsOn) return;                       // 토글 OFF면 어디서도 소리 없음
      if(NO_READ[v]) return;                       // 동의·입력 화면은 낭독 금지
      var q=s.querySelector('.pia-q');              // 검사 문항 우선
      if(q){
        var t=PIA._norm(PIA._elText(q));
        if(t && t!==PIA._norm(PIA._lastRead)){ PIA._lastRead=t; PIA.speak(t); }
        return;
      }
      if(TIP[v]){ var _tv=PIA._norm(TIP[v]); if(_tv && _tv!==PIA._norm(PIA._lastRead)){ PIA._lastRead=_tv; PIA.speak(TIP[v]); } return; }
      var h=s.querySelector('.pia-h1,.pia-display');
      if(h){ var _th=PIA._norm(PIA._elText(h)); if(_th && _th!==PIA._norm(PIA._lastRead)){ PIA._lastRead=_th; PIA.speak(_th); } }
    }catch(e){}
  };
  PIA.greetOnce=function(){
    try{
      if(window._piaGreeted) return;
      var s=document.querySelector('section[data-view]:not(.hidden)');
      if(!s||s.dataset.view!=='home') return;
      if(document.querySelector('.pia-modal, #pia-modal')) return;  // 모달 중엔 금지
      window._piaGreeted=true;
      if(typeof window.piaSpeak==='function') window.piaSpeak(GREET);
      else PIA.speak(GREET);
    }catch(e){}
  };
})();


/* AI 대화 화면에 들어가면 음성 안내를 자동으로 켠다 (사용자가 직접 끈 적이 없을 때만) */
(function(){
  var _o=showView;
  showView=function(n){
    _o(n);
    if(n!=='chat') return;
    try{
      var off=false;
      try{ off = localStorage.getItem('pia_tts')==='0'; }catch(e){}
      if(off) return;
      if(window.PIA && !PIA.ttsOn){
        PIA.ttsOn=true;
        var b=document.getElementById('pia-tts-btn');
        if(b) b.setAttribute('aria-pressed','true');
      }
    }catch(e){ if(window.console) console.error('음성 자동 켜기 실패:', e); }
  };
})();
